import { Tag, TagLabel, Avatar, TagProps } from "@chakra-ui/react";
import { sizeMap } from "helpers/tag";
import SkeletonTag from "./SkeltonTag";

export interface NameTagProps extends TagProps {
  name: string | undefined | null;
  imageUrl?: string | undefined;
  tagLabelProps?: object;
  size?: "xs" | "sm" | "md";
}

export default function NameTag({
  name, imageUrl, tagLabelProps = {}, size = "sm", ...props
}: NameTagProps) {
  if (!name) {
    return <SkeletonTag />;
  }
  const { tagSizeProps, tagLabelSizeProps } = sizeMap(size);
  return (
    <Tag size="lg" colorScheme="gray" maxWidth="none" {...tagSizeProps} {...props}>
      {imageUrl && (
        <Avatar
          src={imageUrl}
          size="xs"
          name={name}
          ml={-1}
          mr={2}
        />
      )}
      <TagLabel
        fontWeight="normal"
        {...tagLabelSizeProps}
        {...tagLabelProps}
      >
        {name}
      </TagLabel>
    </Tag>
  );
}
